import React, { FC } from 'react';
import { Button, Icon, Modal } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { LX_RESUME, LX_RESUME_EDIT } from '@common/const';
import { LxSiteClick } from '@utils/siteLx';

import './index.scss';

interface IProps {
  mode: string;
  type: string;
  setMode: Function;
  setType: Function;
  resumeEnum: {
    socialResume: boolean;
    campusResume: boolean;
  } | null;
  save: Function;
  setChecked: Function;
  setLoading: Function;
}

const ResumeBanner: FC<IProps> = (props) => {
  const { mode, type, setMode, resumeEnum, setType, save, setChecked, setLoading } = props;
  const { campusResumeDetail, socialResumeDetail } = useRootStore();

  let store;
  if (type === 'campus') {
    store = campusResumeDetail;
  }
  if (type === 'social') {
    store = socialResumeDetail;
  }

  const switchResumeTypeView = (val) => {
    const text = val === 'campus' ? '校招' : '社招';
    Modal.confirm({
      className: 'common_modal',
      style: { width: 430, minHeight: 196 },
      title: '切换简历',
      closable: true,
      message: `你当前还未创建${text}简历，是否立即创建`,
      cancelBtnProps: { size: 'large' },
      okBtnProps: { type: 'primary', size: 'large' },
      onOk: async () => {
        setLoading(true);
        setType(val);
        setMode('edit');
        setChecked(false);
      },
    });
  };

  const switchResumeTypeEdit = (val) => {
    Modal.confirm({
      className: 'common_modal',
      style: { width: 430, minHeight: 196 },
      title: '切换简历',
      closable: true,
      message: '是否保存当前简历并切换？',
      cancelBtnProps: { size: 'large' },
      okBtnProps: { type: 'primary', size: 'large' },
      onOk: async () => {
        const res = await save('edit');
        if (res) {
          setLoading(true);
          setType(val);
          setMode('edit');
          setChecked(false);
        }
      },
    });
  };

  const handleChangeType = () => {
    const tmp = type === 'campus' ? 'social' : 'campus';
    LxSiteClick({ bid: tmp === 'campus' ? LX_RESUME_EDIT.switchToCampus : LX_RESUME_EDIT.switchToSocial });
    if (mode === 'view') {
      if (type === 'campus') {
        if (!resumeEnum?.socialResume) {
          switchResumeTypeView(tmp);
        } else {
          setLoading(true);
          setType('social');
          setMode(mode);
        }
      }
      if (type === 'social') {
        if (!resumeEnum?.campusResume) {
          switchResumeTypeView(tmp);
        } else {
          setLoading(true);
          setType('campus');
          setMode(mode);
        }
      }
    }
    if (mode === 'edit') {
      switchResumeTypeEdit(tmp);
    }
  };

  const editResumeDetail = () => {
    LxSiteClick({ bid: LX_RESUME.resumeEdit, valLab: { resumeType: type } });
    setLoading(true);
    setMode('edit');
    setChecked(false);
  };

  return (
    <div className="resume_detail_banner">
      <div className="first_line">
        <Button className="resume_switch" onClick={() => handleChangeType()}>
          切换至{type === 'campus' ? '社招' : '校招'}简历
          <Icon type="cycle" style={{ fontSize: 18 }} />
        </Button>
        {mode === 'view' && (
          <div className="resume_date">
            {store?.updateTime ? `最近更新：${dayjs(store?.updateTime).format('YYYY/MM/DD HH:mm')}` : ''}
          </div>
        )}
      </div>
      <div className="second_line">
        <div className="resume_info">
          <p className="info">
            {mode === 'edit'
              ? `${type === 'campus' ? '编辑校招简历' : '编辑社招简历'}`
              : `${type === 'campus' ? '我的校招简历' : '我的社招简历'}`}
          </p>
          <p>补全简历信息，面试官才能更全面的了解你!</p>
        </div>
        {mode === 'view' && (
          <Button className="resume_edit" onClick={editResumeDetail}>
            编辑简历
          </Button>
        )}
      </div>
    </div>
  );
};

export default observer(ResumeBanner);
